export { default } from "./FeedContent";
